function debounce(fn, delay) {
  let timer = null;
  return function() {
    let args = arguments;

    if (timer) {
      clearTimeout(timer);

      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay);
    } else {
      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay);
    }
  };
}

export { debounce }